// extracted by mini-css-extract-plugin
export default {"h":"styles_h__JZYOk","p":"styles_p__nJBQB","box":"styles_box__QlS-2"};